import React, { useEffect } from "react";
import { Button, ButtonGroup } from "react-bootstrap";

interface ContextMenuCopyProps {
  onClose: () => void;
  onCreateCopy: () => void;
  options: string[];
  style?: React.CSSProperties;
}

const ContextMenuCopy: React.FC<ContextMenuCopyProps> = ({
  onClose,
  onCreateCopy,
  options,
  style,
}) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !event.target ||
        !(event.target as HTMLElement).closest(".context-menu")
      ) {
        onClose();
      }
    };

    document.body.addEventListener("click", handleClickOutside);

    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, [onClose]);

  const handleOptionSelect = (option: string) => {
    switch (option) {
      case "Create Copy":
        onCreateCopy();
        break;
    }
  };

  return (
    <ButtonGroup vertical style={style}>
      {options.map((option, key) => (
        <Button
          key={key}
          variant="secondary"
          onClick={() => handleOptionSelect(option)}
        >
          {option}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ContextMenuCopy;
